import { render, staticRenderFns } from "./componentsListView.vue?vue&type=template&id=5c5a595c&scoped=true"
import script from "./componentsListView.vue?vue&type=script&lang=js"
export * from "./componentsListView.vue?vue&type=script&lang=js"
import style0 from "./componentsListView.vue?vue&type=style&index=0&id=5c5a595c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5a595c",
  null
  
)

export default component.exports